import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_dashboard/$brand/integrations")({
  component: BrandIntegrationsRedirectPage,
});

function BrandIntegrationsRedirectPage() {
  const navigate = useNavigate();
  const { brand } = Route.useParams();

  useEffect(() => {
    navigate({ to: "/$brand/analytics", params: { brand }, replace: true });
  }, [brand, navigate]);

  return null;
}
